(function () {
  'use strict';

  function isReady() {
    return typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.slick === 'function';
  }

  function clearFiniteAutoplayTimer($slider) {
    var timerId = $slider.data('ciCarouselFiniteAutoplayTimer');
    if (timerId) {
      window.clearInterval(timerId);
      $slider.removeData('ciCarouselFiniteAutoplayTimer');
    }
  }

  function bindFiniteAutoplay($slider) {
    clearFiniteAutoplayTimer($slider);
    $slider.off('.ciCarouselFiniteAutoplay');

    var slick = $slider.slick('getSlick');
    var autoplayDelay = (slick && slick.options && slick.options.autoplaySpeed) ? slick.options.autoplaySpeed : 4000;
    var isPaused = false;

    var timerId = window.setInterval(function () {
      if (isPaused || !$slider.hasClass('slick-initialized')) {
        return;
      }

      var sliderInstance = $slider.slick('getSlick');
      if (!sliderInstance || sliderInstance.animating) {
        return;
      }

      var currentSlide = sliderInstance.currentSlide;
      // Keep finite autoplay able to visit the final real slide even with fractional slidesToShow.
      var maxSlideIndex = Math.max(0, sliderInstance.slideCount - 1);
      var nextSlide = currentSlide >= maxSlideIndex ? 0 : currentSlide + 1;

      $slider.slick('slickGoTo', nextSlide);
    }, autoplayDelay);

    $slider.data('ciCarouselFiniteAutoplayTimer', timerId);

    $slider.on('mouseenter.ciCarouselFiniteAutoplay focusin.ciCarouselFiniteAutoplay', function () {
      isPaused = true;
    });

    $slider.on('mouseleave.ciCarouselFiniteAutoplay focusout.ciCarouselFiniteAutoplay', function () {
      isPaused = false;
    });
  }

  function initCarousel(slider) {
    if (!slider || !isReady()) {
      return;
    }

    var $slider = window.jQuery(slider);

    // Prevent duplicate initialization in theme editor/live reload contexts.
    if ($slider.hasClass('slick-initialized')) {
      return;
    }

    var slideCount = $slider.find('.ci-carousel__slide').length;

    if (slideCount <= 1) {
      return;
    }

    var slidesToShow = parseFloat(slider.getAttribute('data-slides-to-show'));
    if (isNaN(slidesToShow) || slidesToShow <= 0) {
      slidesToShow = 1;
    }

    var infiniteMode = slidesToShow > 1 ? false : true;

    var sliderContainer = slider.closest('.ci-carousel__slider-wrapper');
    var prevArrow = sliderContainer ? sliderContainer.querySelector('.slick-prev') : null;
    var nextArrow = sliderContainer ? sliderContainer.querySelector('.slick-next') : null;
    var hasCustomArrows = !!(prevArrow && nextArrow);

    try {
      $slider.slick({
        infinite: infiniteMode,
        speed: 500,
        fade: false,
        centerMode: false,
        rtl: false,
        initialSlide: 0,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: infiniteMode,
        autoplaySpeed: 4000,
        dots: false,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ],
        prevArrow: hasCustomArrows ? prevArrow : '<button type="button" class="slick-prev" aria-label="Previous slide"></button>',
        nextArrow: hasCustomArrows ? nextArrow : '<button type="button" class="slick-next" aria-label="Next slide"></button>',
        adaptiveHeight: false,
        accessibility: true,
        pauseOnHover: true,
        pauseOnFocus: true
      });
      if (!infiniteMode) {
        bindFiniteAutoplay($slider);
      }
    } catch (error) {
      // Fallback for rare Slick ADA init failures in dynamic editor refreshes.
      $slider.slick({
        infinite: infiniteMode,
        speed: 500,
        fade: false,
        centerMode: false,
        rtl: false,
        initialSlide: 0,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: infiniteMode,
        autoplaySpeed: 4000,
        dots: false,
        arrows: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ],
        prevArrow: hasCustomArrows ? prevArrow : '<button type="button" class="slick-prev" aria-label="Previous slide"></button>',
        nextArrow: hasCustomArrows ? nextArrow : '<button type="button" class="slick-next" aria-label="Next slide"></button>',
        adaptiveHeight: false,
        accessibility: false,
        pauseOnHover: true,
        pauseOnFocus: true
      });
      if (!infiniteMode) {
        bindFiniteAutoplay($slider);
      }
    }
  }

  function initAllCarousels() {
    if (!isReady()) {
      window.setTimeout(initAllCarousels, 100);
      return;
    }

    var sliders = document.querySelectorAll('[data-ci-carousel]');
    sliders.forEach(function (slider) {
      initCarousel(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sectionId = e.detail.sectionId;
    var slider = document.querySelector('[data-ci-carousel][data-section-id="' + sectionId + '"]');
    if (slider) {
      initCarousel(slider);
    }
  });
})();
